module.exports = __webpack_public_path__ + "92ba59327c74453ebe285c015b33a57e.pdf";